class TubeAgeGate extends HTMLElement {
  connectedCallback() {
    this.storageKey = this.dataset.storageKey || 'tubeAgeVerified';
    this.minimumAge = Number(this.dataset.minimumAge || 18);
    this.storageDays = Number(this.dataset.storageDays || 30);
    this.mode = this.dataset.mode || 'buttons';
    this.error = this.querySelector('[data-age-error]');
    this.previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.boundClick = this.onClick.bind(this);
    this.boundSubmit = this.onSubmit.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);

    if (this.isVerified()) {
      this.hideGate();
      return;
    }

    this.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', this.boundKeydown);
    this.addEventListener('click', this.boundClick);
    this.addEventListener('submit', this.boundSubmit);
    window.requestAnimationFrame(() => this.focusFirstControl());
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.boundKeydown);
  }

  isVerified() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(this.storageKey) || 'null');
      return saved?.expiresAt && Date.now() < saved.expiresAt;
    } catch (_error) {
      return false;
    }
  }

  approve() {
    const expiresAt = Date.now() + this.storageDays * 24 * 60 * 60 * 1000;
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify({ expiresAt }));
    } catch (_error) {
      // Some privacy modes block storage; approving should still unblock this visit.
    }
    this.hideGate();
  }

  hideGate() {
    this.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', this.boundKeydown);
    if (this.previouslyFocused) this.previouslyFocused.focus();
  }

  deny() {
    if (this.error) this.error.textContent = this.dataset.denyMessage || 'Du bist leider noch nicht alt genug.';
  }

  onClick(event) {
    const action = event.target.closest('[data-age-action]')?.dataset.ageAction;
    if (!action) return;
    if (action === 'approve') this.approve();
    if (action === 'deny') this.deny();
  }

  onSubmit(event) {
    event.preventDefault();
    const field = this.querySelector('[name="tube_birthdate"]');
    if (!field?.value) {
      this.deny();
      return;
    }

    const birthdate = new Date(`${field.value}T00:00:00`);
    const today = new Date();
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDelta = today.getMonth() - birthdate.getMonth();
    const dayDelta = today.getDate() - birthdate.getDate();

    if (monthDelta < 0 || (monthDelta === 0 && dayDelta < 0)) age -= 1;
    if (age >= this.minimumAge) this.approve();
    else this.deny();
  }

  onKeydown(event) {
    if (event.key !== 'Tab' || this.hidden) return;

    const focusable = this.getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  focusFirstControl() {
    const first = this.getFocusableElements()[0];
    if (first) first.focus();
  }

  getFocusableElements() {
    return [...this.querySelectorAll('button, input, select, textarea, a[href]')]
      .filter((element) => !element.disabled && element.offsetParent !== null);
  }
}

customElements.define('tube-age-gate', TubeAgeGate);
